import { render } from "./MessageElement.vue?vue&type=template&id=d59604ac&scoped=true"
import script from "./MessageElement.vue?vue&type=script&lang=js"
export * from "./MessageElement.vue?vue&type=script&lang=js"

import "./MessageElement.vue?vue&type=style&index=0&id=d59604ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59604ac"]])

export default __exports__